import React from "react";

const SvgBBiconsRozbalitVse = props => (
    <svg viewBox="0 0 200 200" {...props}>
        <g id="Obecné_ikony" data-name="Obecné ikony">
            <g id="Sipky">
                <path d="M59.54,50.13A9.08,9.08,0,0,0,53,65.61l40.26,40.73a9.05,9.05,0,0,0,12.83.08L146.9,66.19a9.1,9.1,0,0,0-12.79-12.94L99.84,87.13,66,52.82A9.16,9.16,0,0,0,59.54,50.13Zm0,52.78A9.11,9.11,0,0,0,53,118.39l40.26,40.78a9.06,9.06,0,0,0,12.83.07L146.9,119a9.09,9.09,0,0,0-12.79-12.91L99.84,140,66,105.64A9.21,9.21,0,0,0,59.54,102.91Z"/>
            </g>
        </g>
    </svg>
);

export default SvgBBiconsRozbalitVse;

